export const formConfigUtils = {
    validateNum({ value, min, max }) {
        if (
            value !== null && value !== undefined &&
            (
                (min !== undefined && value < min) ||
                (max !== undefined && value > max)
            )
        ) {
            return `${min} - ${max}`;
        }
        return null;
    },

    validateMin: ({ maxFieldName, min, max }) => (value, values) => {
        const otherValue = values[maxFieldName];

        if (value !== null && value !== undefined && otherValue !== null && otherValue !== undefined) {
            if (value > otherValue) {
                return 'Min is greater than max';
            } else if (value >= otherValue && !formConfigUtils.validateNum({ value: otherValue, min, max })) {
                return { clearErrorFor: maxFieldName };
            }
        }

        return formConfigUtils.validateNum({ value, min, max });
    },

    validateMax: ({ minFieldName, min, max }) => (value, values) => {
        const otherValue = values[minFieldName];

        if (value !== null && value !== undefined && otherValue !== null && otherValue !== undefined) {
            if (value < otherValue) {
                return 'Max is less than min';
            } else if (value >= otherValue && !formConfigUtils.validateNum({ value: otherValue, min, max })) {
                return { clearErrorFor: minFieldName };
            }
        }

        return formConfigUtils.validateNum({ value, min, max });
    },
};



// WEBPACK FOOTER //
// ./app/components/common/Form/formConfig.utils.js